import {
  HEADER_ROW_TEMPLATE,
  ROW_TEMPLATE,
  TIMEBAND_LEVEL_NAME,
  OUTER_LEVEL_NAME,
  SECTOR_LEVEL_NAME,
  POSTCODE_LEVEL_NAME,
} from "../consts/volumeOverlayTable";

export const getUpdatedRows = (id, rows) => {
  const clickedRow = rows[id];
  const { postcode, isHeaderRow } = clickedRow;
  if (isHeaderRow || postcode) return rows;
  if (!clickedRow.extended) return injectChildRows(clickedRow, rows);
  else return removeChildRows(clickedRow, rows);
};

export const injectChildRows = (clickedRow, rows) => {
  clickedRow.extended = true;
  const { id, level, timeband, outer, sector } = clickedRow;
  const rowsAboveInjection = rows.slice(0, id + 1);

  let sourceKey = "outerDetails";
  let nameKey = "outer";
  let headerName = OUTER_LEVEL_NAME;
  let injectionLevel = OUTER_LEVEL_NAME;
  if (level === SECTOR_LEVEL_NAME) {
    sourceKey = "postcodes";
    nameKey = "postcode";
    headerName = POSTCODE_LEVEL_NAME;
    injectionLevel = POSTCODE_LEVEL_NAME;
  } else if (level === OUTER_LEVEL_NAME) {
    sourceKey = "sectors";
    nameKey = "sector";
    headerName = SECTOR_LEVEL_NAME;
    injectionLevel = SECTOR_LEVEL_NAME;
  }

  const injectionRows = [
    {
      ...HEADER_ROW_TEMPLATE,
      id: id + 1,
      timeband,
      name: headerName,
      level: injectionLevel,
    },
  ];
  clickedRow[sourceKey].forEach((row, i) =>
    injectionRows.push({
      ...ROW_TEMPLATE,
      timeband,
      outer,
      sector,
      ...row,
      id: id + 2 + i,
      name: row[nameKey],
      level: injectionLevel,
    })
  );

  const rowsBelowInjection = rows.slice(id + 1).map((row, i) => ({
    ...(row.isHeaderRow ? HEADER_ROW_TEMPLATE : ROW_TEMPLATE),
    ...row,
    id: id + 1 + i + injectionRows.length,
  }));
  return [...rowsAboveInjection, ...injectionRows, ...rowsBelowInjection];
};

export const removeChildRows = (clickedRow, rows) => {
  clickedRow.extended = false;
  const { id, level } = clickedRow;

  const rowsAboveRemoval = rows.slice(0, id + 1);
  const isOfEqualOrHigherLevel = (id) => {
    const row = rows[id];
    if (level === TIMEBAND_LEVEL_NAME) return row.level === TIMEBAND_LEVEL_NAME;
    else if (level === OUTER_LEVEL_NAME)
      return [TIMEBAND_LEVEL_NAME, OUTER_LEVEL_NAME].includes(row.level);
    else return row.level !== POSTCODE_LEVEL_NAME;
  };

  let rowsToRemove = 1;
  for (rowsToRemove; rowsToRemove + id < rows.length; rowsToRemove++)
    if (isOfEqualOrHigherLevel(rowsToRemove + id)) break;

  const rowsBelowRemoval = rows.slice(id + rowsToRemove).map((row, i) => ({
    ...(row.isHeaderRow ? HEADER_ROW_TEMPLATE : ROW_TEMPLATE),
    ...row,
    id: id + 1 + i,
  }));
  return [...rowsAboveRemoval, ...rowsBelowRemoval];
};
